import PropTypes from 'prop-types'
import { useMemo } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ListTabs from 'components/shared/list-tabs'
import {
  REFERRAL_HISTORY_TAB,
  REFERRAL_HISTORY_LOCIZE,
} from 'components/referral/landing/landing-desktop/history/const'
import referralHistoryDuck from '../duck'

const ReferralHistoryTab = ({ selectedTab, updateSelectedTab, orderCount }) => {
  const TABS = useMemo(
    () => [
      {
        tab: REFERRAL_HISTORY_TAB.IN_PROGRESS,
        key: REFERRAL_HISTORY_LOCIZE.REFERRAL_HISTORY_IN_PROGRESS_TAB.key,
        text: REFERRAL_HISTORY_LOCIZE.REFERRAL_HISTORY_IN_PROGRESS_TAB.text,
        num: orderCount.in_progress,
      },
      {
        tab: REFERRAL_HISTORY_TAB.SUCCESS,
        key: REFERRAL_HISTORY_LOCIZE.REFERRAL_HISTORY_SUCCESS_TAB.key,
        text: REFERRAL_HISTORY_LOCIZE.REFERRAL_HISTORY_SUCCESS_TAB.text,
        num: orderCount.success,
      },
      {
        tab: REFERRAL_HISTORY_TAB.IN_COMPLETE,
        key: REFERRAL_HISTORY_LOCIZE.REFERRAL_HISTORY_IN_COMPLETE_TAB.key,
        text: REFERRAL_HISTORY_LOCIZE.REFERRAL_HISTORY_IN_COMPLETE_TAB.text,
        num: orderCount.incomplete,
      },
    ],
    [orderCount],
  )

  const isTabSelected = (tab) => tab === selectedTab

  return (
    <ListTabs
      tabs={TABS}
      handleClick={updateSelectedTab}
      isTabSelected={isTabSelected}
    />
  )
}

ReferralHistoryTab.defaultProps = {
  orderCount: {
    incomplete: 0,
    in_progress: 0,
    success: 0,
  },
}

ReferralHistoryTab.propTypes = {
  selectedTab: PropTypes.string.isRequired,
  updateSelectedTab: PropTypes.func.isRequired,
  orderCount: PropTypes.shape({
    incomplete: PropTypes.number,
    in_progress: PropTypes.number,
    success: PropTypes.number,
  }),
}

export default connect(
  (state) => ({
    selectedTab: state.referralHistory.selectedTab,
    orderCount: state.referralHistory.orderCount,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        updateSelectedTab: referralHistoryDuck.creators.updateSelectedTab,
      },
      dispatch,
    ),
)(ReferralHistoryTab)
